// dependencies
import useragentParser from "ua-parser-js";

const parseUserAgent = (userAgent) => {
	const useragentObject = useragentParser(userAgent);

	if (!useragentObject.browser.name) {
		useragentObject.browser.name = "default";
	}

	return useragentObject;
};

export default parseUserAgent;
